import dayjs from "dayjs";

const ColumnSort = {
    Date: (key, dir = "asc") => (a, b) => dir === "asc" ?  dayjs(a[key]).diff(dayjs(b[key])) : dayjs(b[key]).diff(dayjs(a[key])),
    Number: (key, dir = "asc") => (a, b) => dir === "asc" ? Number(a[key]) - Number(b[key]) : Number(b[key]) - Number(a[key])
}

export default ColumnSort;